export default __webpack_public_path__ + "static/media/goebel.efd57591.jpg";